module.exports = __webpack_public_path__ + "img/2025-03-12c_2.d960468c.jpg";